import { useRouter } from 'next/router';

import I18n from '~/src/common/services/I18n/I18n';
import { useGetCategories } from '~/src/queries/api-ecom/generated/api-ecom';
import useBreadcrumbs from '~/src/screens/CatalogContent/ContentScreen/hooks/useBreadcrumbs';
import { RecipeScreenSkeleton } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/RecipeScreenSkeleton/RecipeScreenSkeleton';
import useRecipe from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/hooks/useRecipe';
import RecipeContent from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/RecipeContent';
import { CatalogContentNotFound } from '~/src/screens/CatalogContent/ContentScreen/shared/CatalogContentNotFound/CatalogContentNotFound';
import { CatalogContentLinkQueryParams } from '~/src/screens/CatalogContent/ContentScreen/types';

import { context as RecipeScreenContext } from './context';

const DEFAULT_SERVINGS = 4;

const RecipeScreen = () => {
  const {
    query: { slug, eventSource },
  } = useRouter<CatalogContentLinkQueryParams>();

  const { recipe, servings, handleChangeServings, error } = useRecipe(slug);

  const { data: categories } = useGetCategories();

  const categoriesBreadcrumbs = useBreadcrumbs(categories, recipe?.breadcrumbs);
  const categoryName = categoriesBreadcrumbs[0]?.name;
  // Cas spécifique pour les produits qui sont dans une sous-catégorie de la home
  // Les infos sont dans le 1er élément du tableau car pas de catégories parentes
  const subcategoryName = categoriesBreadcrumbs[1]?.name ?? categoriesBreadcrumbs[0]?.name ?? '';

  if (error) return <CatalogContentNotFound title={I18n.t('recipe-screen.not-found')} />;
  if (recipe == null) return <RecipeScreenSkeleton />;

  return (
    <RecipeScreenContext.Provider
      value={{ eventSource, categoryName, subcategoryName, recipe, categoriesBreadcrumbs }}>
      <RecipeContent
        recipe={recipe}
        categories={categories}
        onChangeServings={handleChangeServings}
        // Le nombre de personnes de la recette par défaut est utilisé pour le premier rendu de l'interface
        // Côté serveur le prefetch est réalisé sans le paramètre servings, néanmions il convient d'initialiser
        // les informations de la page
        servings={servings ?? DEFAULT_SERVINGS}
      />
    </RecipeScreenContext.Provider>
  );
};

export default RecipeScreen;
